<template>
  <div class="payment">
    <div style="width: 100%; display: flex;" justify-content-center>
        <div class="payment-container">
          <div v-if="isError" style="padding: 2em 0;">
            <h1>Oops! Something went wrong.</h1>
            <p>Error: Unable to proceed, no active payment is found.</p>
            <ion-button style="margin-top: 2em;" expand="full" @click="$router.push('/')">HOME</ion-button>
          </div>
          <div v-else>
            <ion-list v-if="subscription.type">
                <ion-item>
                    <ion-label position="fixed">Type</ion-label>
                    <ion-label>{{subscriptionLabel}}</ion-label>
                </ion-item>
                <ion-item v-if="subscription.type_.label != 'Free'">
                    <ion-label position="fixed">Payment</ion-label>
                    <ion-label>{{subscription.payment.label}}</ion-label>
                </ion-item>
                <ion-item v-if="subscription.type_.label != 'Free'">
                    <ion-label position="fixed">Date</ion-label>
                    <ion-label>{{formatDate(subscription.payment.date)}}</ion-label>
                </ion-item>
                <ion-item v-if="subscription.type_.label != 'Free'">
                    <ion-label position="fixed">Price</ion-label>
                    <ion-label>&#8369; {{subscription.type_.price}}</ion-label>
                </ion-item>
            </ion-list>
            <!-- <ion-datetime placeholder="Choose Date"></ion-datetime>
            <ion-input placeholder="Choose Date"></ion-input> -->
            <ion-list lines="inset" inset="true" class="ion-no-margin ion-no-padding">
                <ion-item v-if="subscription.payment.proof.date">
                    <ion-label position="stacked">Date of Deposit</ion-label>
                    <ion-input @click="open" :value="formatDate(subscription.payment.proof.date)" type="text"></ion-input>
                </ion-item>
                <!-- <ion-item>
                    <ion-label position="floating">Reference No.</ion-label>
                    <ion-input :value="subscription.payment.proof.reference" @change="onInputChange"></ion-input>
                </ion-item> -->
                <div style="padding: 0.5em"></div>
                <ion-item>
                    <ion-label position="stacked">Upload proof of Payment (required)</ion-label>
                   <div style="width: 100%;">
                       <div class="img-container" @click="addPhoto">
                           <div class="img-text-container">
                                <h4 class="img-text">Click to change photo</h4>
                           </div>
                           <img class="img-view" :src="currentImg"/>
                       </div>
                   </div>
                   <input ref="uploadButton" style="display: none;" type="file" @change="onChange" accept="image/*"/>
                </ion-item>
                <div style="padding: 0.5em"></div>
                <ion-button expand="block" @click="onSubmit" fill="outline" v-if="isChanged">Save</ion-button>
                <ion-button expand="block" fill="solid" @click="$router.push('/')" v-else>Done</ion-button>
            </ion-list>
          </div>
        </div>
    </div>

    <div v-if="popupContent" id="popupMenu" style="display:none">
            <div style="padding: 0.5em;">
              <DatePicker
              title-position="left"
              :is-dark="$store.state.settings.settings.theme == 'dark'"
              trim-weeks
              :max-date="new Date()"
              mode="date"
              @dayclick="onDayClick"
              color="green"
              :value="subscription.payment.proof.date"
              />
            </div>
      </div>
  </div>
</template>
<script>

let popupTimeout = null;

import config from "../../config.js";
import { format, isFuture } from "date-fns";
import Calendar from 'v-calendar/lib/components/calendar.umd';
import DatePicker from 'v-calendar/lib/components/date-picker.umd';

export default {
  data() {
    return {
      subscription: {
        payment: {
          date: "",
          label: "",
          proof: {
            date: "",
            img: "",
            reference: ""
          }
        }
      },
      img: {
        url: "",
        img: ""
      },
      popupContent: false,
      isChanged: true,
      isError: false
    }
  },

  methods: {
    async getSubscription() {
      const res = await this.$http({
        method: "GET",
        url: config.api.url + "/subscribe/payment",
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
        }
      });
      if(res) {
        if(res.data) {
          if(res.data.length > 0) {
            let data = res.data[0];

            if(data.payment.proof.date == null) {
              data.payment.proof.date = format(new Date, "MM-dd-yyyy");
            }

            this.subscription = data;
            return;
          }
        }
      }
      this.isError = true;
    },
    formatDate(date) {
      return format(new Date(date), 'MMM. dd, yyyy');
    },

    onChange(e) {
        this.isChanged = true;
        if(e.target.files[0]) {
            this.img = {
                img: e.target.files[0],
                url: URL.createObjectURL(e.target.files[0])
            };
        }
    },
    addPhoto() {
        this.$refs["uploadButton"].click();
    },
    open(evt) {
      this.popupContent = false; // re-create always
      setTimeout(() => {
        this.popupContent = true;
        this.$ionic.showPopover(evt, {
          template: "popupMenu",
          cssClass: "date-picker-popup-width",
          translucent: true
        });
      }, 100);
    },
    onDayClick(day) {
      var result = isFuture(day.date);
      if(result) {
        return;
      }
      this.subscription.payment.proof.date = format(day.date, "MM-dd-yyyy");
      popupTimeout = setTimeout(()=>{
        this.$ionic.dismissPopover();
      }, 300);
    },
    onInputChange(evt) {
      this.subscription.payment.proof.reference = evt.target.value;
    },
    async onSubmit() {

      if(!this.img.img && !this.subscription.payment.proof.img) {
        this.$ionic.showToast("Please select a photo of your proof of Payment.", {
          position: "bottom",
          duration: 3000
        });
        return;
      }

      await this.$ionic.showLoading("Submitting...", "cresent");

      if(this.img.img) {
        let fd = new FormData();
        fd.append('files', this.img.img);

        const res = await this.$http({
          method: "POST",
          url: config.api.url + "/subscribe/upload",
          data: fd
        });

        if(res.data.length > 0) {
          const imgUrl = res.data[0].url.replace(/^[a-z]{4}\:\/{2}[a-z]{1,}\:[0-9]{1,4}.(.*)/, '$1');
          this.subscription.payment.proof.img = imgUrl;
        } else {
          await this.$ionic.dismissLoading();
          this.$ionic.showToast("Upload failed. Something went wrong.", {
            position: "bottom"
          });
          return;
        }
      }

      const r = await this.$http({
        method: "PUT",
        url: config.api.url + "/subscribe/" + this.subscription.id,
        data: this.subscription
      });

      if(r.data) {
        this.subscription = r.data;
        await this.$ionic.dismissLoading();
        this.$ionic.showToast("Saved. We will send you an email for the payment confirmation.", {
          position: "bottom"
        });
        this.isChanged = false;
      }
    }
  },
  computed: {
    subscriptionLabel() {
      if(this.subscription.type) {
        return this.subscription.type_.label.replace("<br/>", " ").replace("Free", "");
      }
      return "Free";
    },
    maxDate() {
        // return format(new Date, 'yyyy-MM-dd');
        return '2022-05-04';
    },

    currentImg(){
      if(!this.img.url && !this.subscription.payment.proof.img) {
        return;
      }

      if(this.img.url) {
        return this.img.url;
      }

      return config.subscription.url + this.subscription.payment.proof.img;
    }

  },

  watch: {
    "subscription.payment.proof.date": {
       handler(val, oldVal){

        if(!oldVal) {
          return;
        }

        if(val !== oldVal) {
          this.isChanged = true;
        }

      }
    },
    "subscription.payment.proof.reference": {
       handler(val, oldVal){

        if(!oldVal) {
          return;
        }

        if(val !== oldVal) {
          this.isChanged = true;
        }

      },
      deep: true
    }
  },

  mounted() {
      this.getSubscription();
  },
  beforeDestroy() {
    clearTimeout(popupTimeout);
  },
  components: {
    Calendar,
    DatePicker
  }
};
</script>

<style scoped>
  /* ion-button {
    color: #fff !important;
  } */
  ion-icon[name="checkmark-circle"] {
    color: #18bc9c;
  }

  ion-icon[name="close-circle"] {
    color: #ff5858;
  }

  .payment table {
      min-width: 400px;
  }

  .payment table tbody tr td {
    vertical-align: top;
    padding-top: 10px;
  }

  .sub-popup {
    padding: 1.25em 1em;
    width: 100%;
  }

  .sub-buttons {
    display: flex;
    width: 100%;
  }

  .sub-buttons button:before{
    content:'';
    float:left;
    padding-top:100%;
  }

  .sub-buttons button div{
   height: 100%;
  }

  .sub-buttons ion-button {
    margin: 0.5em 0;
  }

  .sub-buttons button div h3, .sub-buttons button div h4 {
    /* color: #ffffff; */
    margin: 0 0 5px 0;
  }

  .sub-buttons button div h4 {
    position: absolute;
    bottom: 15px;
    left: 50%;
    transform: translate(-50%, 0);
  }

  .price-col {
    padding: 0 5px 0 1.5em;
    text-align: right;
  }

  .img-container {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    min-height: 200px;
    cursor: pointer;
  }
  .img-view {
     max-width: 100%;
  }
  .img-text {
    font-weight: 500;
    color: #000;
  }

  .img-text-container {
    width: 100%;
    height: 100%;
    background-color: rgba(255,255,255,0.3);
    display: flex;
    min-height: 200px;
    justify-content: center;
    align-items: center;
    z-index: 10;
    position: absolute;
    top: 0;
    left: 0;
  }

  @media (min-width: 550px) {
    .payment-container {
      width: 500px;
    }
  }
</style>
